module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', {
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    on: {
      "change": _vm.changeCampaign
    },
    model: {
      value: (_vm.campaignID),
      callback: function($$v) {
        _vm.campaignID = $$v
      },
      expression: "campaignID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('SummaryBoxes', {
    attrs: {
      "refresh": _vm.isRefresh,
      "campaignID": _vm.campaignID
    }
  })], 1), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.campaignID),
      expression: "campaignID"
    }]
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('timeline-data-table', {
    attrs: {
      "refresh": _vm.isRefresh,
      "campaignID": _vm.campaignID,
      "selectedCampaign": _vm.selectedCampaign
    },
    on: {
      "updated": _vm.invokeTimelineUpdated
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b5aa10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/Timeline/index.vue
// module id = 2156
// module chunks = 0